module.exports = __webpack_public_path__ + "img/1530692590.f10b38a9.jpg";